<template>
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <router-link to="/instruction"  tag="button">
    <v-btn
            class="mr-2"
            large
            color="dark"
            v-bind="attrs" v-on="on"
            >
            <span class = "font-weight-black text-h5">Tutorial</span>
    </v-btn>
    </router-link>
    </template>
    <span style="font-size:100%">Click to View the Tutorial</span>
    </v-tooltip>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <v-btn
            class="ma-2"
            large
            fab
            color="dark"
            v-bind="attrs" v-on="on"
            @click="view_statistics"
            >
            <span class = "font-weight-black text-h5">{{count_labeled_graph}}</span>
    </v-btn>
    </template>
    <span style="font-size:100%">Click to View User Statistics</span>
    </v-tooltip>
    <div v-if=dialog>
     <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="dialog"
      >        
        <v-card>
          <v-toolbar dark>Statistics</v-toolbar>
          <div class="text-h5 pa-5">You have labeled <span class = "font-weight-black">{{count_labeled_graph}}</span> graphs in total.</div>
          <div v-if=avg_spent class="text-h5 pa-5">You spent <span class = "font-weight-black">{{avg_spent}}</span> seconds per graph on average.</div>
          <div v-if=is_admin>
          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by one person</div>        
          <v-progress-linear
              v-bind:value = "label_once_perc"
              height = "25"
              color = "red lighten-2"
            >  
            <strong>{{label_once_perc}}%</strong>
          </v-progress-linear>
          
          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by two people</div>        
          <v-progress-linear
              v-bind:value = "label_twice_perc"
              height = "25"
              color="teal lighten-2"
            >  
            <strong>{{label_twice_perc}}%</strong>
          </v-progress-linear>

          <div class="text-h6 pa-5 font-italic">Percentage of graphs have been labeled by three people</div>        
          <v-progress-linear
              v-bind:value = "label_thrice_perc"
              height = "25"
              color = "purple lighten-3"
            >  
            <strong>{{label_thrice_perc}}%</strong>
          </v-progress-linear>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="dark" text x-large rounded outlined @click="dialog=false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
      <div v-if=congrat_dialog>
      <v-dialog v-model="congrat_dialog" max-width="600" transition="dialog-top-transition">                    
      <v-card>
      <v-toolbar dark> Thank You </v-toolbar>
      <v-card-text class= "text-h5 pa-5">Good job! You have labeled <span class = "font-weight-black">{{count_labeled_graph}}</span> graphs.</v-card-text>
      <v-card-text class= "text-h5 pa-5">You have labeled more graphs than <span class = "font-weight-black">{{rank}}</span> % of users.</v-card-text>
      <v-card-text class= "text-h5 pa-5 pb-10">Please keep up the great work!</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="dark" text x-large rounded outlined @click="congrat_dialog=false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
    </v-app-bar>
    <v-main>
<div>
<v-layout>
  <v-card-actions class="justify-left">
  <h2 class = "ml-1">Please select one out of eight drawing you like the most.</h2>
  </v-card-actions>
  <v-card-actions class="justify-center">
    <div class = "text-center">
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <v-btn class = "ml-16" color="dark" rounded x-large v-bind="attrs" v-on="on" @click="back_to_prev">
    <v-icon dark>
        mdi-arrow-left
    </v-icon>
      Back
    </v-btn>
    </template>
    <span style="font-size:100%">Back to Previously Skipped Graph</span>
    </v-tooltip>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <v-btn class = "ml-10 mr-16" color="dark" rounded x-large v-bind="attrs" v-on="on" @click="skip_graph">
      Next
      <v-icon dark>
        mdi-arrow-right
      </v-icon>
    </v-btn>
    </template>
    <span style="font-size:100%">Skip the Current Graph</span>
    </v-tooltip>
    </div>
    </v-card-actions>
    <v-card-actions class="justify-right">
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <div v-on="on" v-bind="attrs">
    <v-checkbox class ="ml-16" v-model="hardcheck" color="red darken-3" label = "Is this hard?"></v-checkbox>
    </div>
    </template>
    <span style="font-size:100%">Please Check This Box If You Think You've Made a Hard Choice</span>
    </v-tooltip>
    <v-tooltip bottom>
    <v-spacer></v-spacer>
    <template v-slot:activator="{ on, attrs }">
    <v-btn class = "ml-16" color="dark" rounded x-large v-bind="attrs" v-on="on" @click="quit">
      Quit
    </v-btn>
    </template>
    <span style="font-size:100%">End the Current Session</span>
    </v-tooltip>
    </v-card-actions>
</v-layout>

<v-row>
    <v-col
      v-for="(item,i) in 8"
      :key="i"
      class="d-flex child-flex"
      cols="3"
    >
    <v-card class="ml-3 mt-3">
     <v-img
        v-bind:src="'https://gan-layout.s3.us-east-2.amazonaws.com/rome/'+graph_id+'/'+file_name[i]+'.png'"
        aspect-ratio="1.5"
        class="grey lighten-2"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-card-actions class="justify-center">
      <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
      <v-btn
            class="ma-2"
            outlined
            large
            color="red"
            v-bind="attrs"
            v-on="on"
            @click="choose_layout(file_name[i])"
            >
            <v-icon>mdi-heart</v-icon>
        </v-btn>
        </template>
        <span style="font-size:150%">Is This the One You Like Most?</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
    </v-col>
  </v-row>
</div>
</v-main>
</v-app>
</template>

<script>

export default {
  name:'Labelling',
  title: 'Label Graph Layouts',
  data() {
    return{
      file_name: [],
      graph_id:this.$route.params.graphid,
      user_id:this.$route.params.userid,
      username:this.$route.params.username,
      hardcheck:false,
      start_time:null,
      dialog:false,
      count_labeled_graph:null,
      avg_spent:null,
      label_once_perc:null,
      label_twice_perc:null,
      label_thrice_perc:null,
      has_prev:true,
      is_admin:null,
      congrat_dialog:false,
      rank:null,
    }
  },
  created() {
    var congrat_number = 50
    this.start_time  = new Date().getTime();
    var algorithms= ['fa2','fdp','kamada_kawai','neato','pmds','sfdp','spectral','spring'];
    for (var i = algorithms.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = algorithms[i];
        algorithms[i] = algorithms[j];
        algorithms[j] = temp;
    }
    this.file_name = algorithms;
    fetch(`http://localhost:5000/get_count_rank/${this.user_id}/`,{
      method: "GET",
      headers:{
        "Content-Type": "application/json"
      }})
      .then(resp => {
        return resp.json()
      })
      .then(data => {
        this.count_labeled_graph = data.count
        if (data.count >= congrat_number && data.count% congrat_number == 0 ){
          this.rank = data.rank
          this.congrat_dialog = true
        }
      })
  },
  methods:{
    choose_layout: function (chosen_layout){

      // calculate the seconds difference
      var end_time = new Date().getTime();
      var second_diff = ((end_time - this.start_time)/1000).toFixed(4);
      fetch(`http://localhost:5000/label_graph`,{
          method: "POST",
          headers:{
            "Content-Type": "application/json"
          },
          body: JSON.stringify({graph_id:this.graph_id, user_id:this.user_id, chosen_layout:chosen_layout, seconds_spent:second_diff, is_hard:this.hardcheck})  
      })
       .then(resp => {
          fetch(`http://localhost:5000/next_graph/${this.username}/`,{
            method: "GET",
            headers:{
              "Content-Type": "application/json"
            }})
            .then(resp => {
              return resp.json()
            })
            .then(data => {
              this.$router.push({path:'/labelling/'+data.user_id+"/"+this.username+"/"+data.graph_id})
            })
          return resp.json()
        })
        .catch(error => {
        console.log(error)
      })
    },
    view_statistics: function (){
      this.dialog = true;
      fetch(`http://localhost:5000/user_statistics/${this.user_id}/`,{
            method: "GET",
            headers:{
              "Content-Type": "application/json"
            }})
            .then(resp => {
              return resp.json()
            })
            .then(data => {
              this.is_admin = data.is_admin
              this.avg_spent = data.avg_spent
              this.label_once_perc = data.label_once_perc
              this.label_twice_perc = data.label_twice_perc
              this.label_thrice_perc = data.label_thrice_perc
            })
    },
    skip_graph: function(){
        fetch(`http://localhost:5000/skip_graph/${this.user_id}/${this.username}/${this.graph_id}/`,{
        method: "GET",
        headers:{
          "Content-Type": "application/json"
        }})
        .then(resp => {
          return resp.json()
        })
        .then(data => {
          this.$router.push({path:'/labelling/'+data.user_id+"/"+this.username+"/"+data.graph_id})
        })
    },
    back_to_prev:function(){
      fetch(`http://localhost:5000/back_to_prev/${this.user_id}/${this.graph_id}/`,{
        method: "GET",
        headers:{
          "Content-Type": "application/json"
        }})
        .then(resp => {
          if (resp.status === 400){
            this.has_prev = false
          }
          return resp.json()
        })
        .then(data => {
          if (this.has_prev === true){
            this.$router.push({path:'/labelling/'+data.user_id+"/"+this.username+"/"+data.graph_id})
          }
        })
    },
    quit:function(){
      fetch(`http://localhost:5000/quit/${this.user_id}/`,{
        method: "GET",
        headers:{
          "Content-Type": "application/json"
        }})
        .then(resp => {
          this.$router.push({path:'/end/' + this.user_id})
          return resp.json()
        })
    }
  }
}
</script>
